export default __webpack_public_path__ + "static/media/dyed-woodcurls.1ce09c21.jpg";